module.exports = __webpack_public_path__ + "60baa420f01453a947b21abf0895ffc4.svg";